/**
 * Lib.Common: v-label-next directive
 *
 * Event handler for v-label `next` action button.
 */


function bind(el, binding, vnode) {
    el._lnext = binding.value;
}


function unbind(el) {
    delete el._lnext;
}


export default {
    name: 'label-next',
    directive: {
        bind,
        unbind,
        update: bind
    }
};
